import React from "react";

import { AppLayout } from "@amzn/awsui-components-react";
import { LandingPageContent } from "src/components/landing-page/LandingPageContent";

export function LandingPage() {
  return (
    <AppLayout
      disableContentPaddings={true}
      content={<LandingPageContent />}
      navigationHide={true}
      toolsHide={true}
      headerVariant="high-contrast"
    />
  );
}
